import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PinDropIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pin_drop"}/>
}
